import { render, staticRenderFns } from "./related.vue?vue&type=template&id=0aa0e06b&scoped=true"
import script from "./related.vue?vue&type=script&lang=js"
export * from "./related.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa0e06b",
  null
  
)

export default component.exports